/**
 * DetailItemTitleContainer component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled detail item title container.
 */
const DetailItemTitleContainer = styled.div<React.CSSProperties>`
  color: ${Colors['text']};
  font-family: ${Fonts['bold']};
  font-size: ${32 * Screen.widthRatio}px;
  line-height: ${40 * Screen.widthRatio}px;
  margin-right: ${16 * Screen.widthRatio}px;
  text-align: start;
  width: ${185 * Screen.widthRatio}px;
`;

export default DetailItemTitleContainer;
